export default __webpack_public_path__ + "static/media/red-mountain-5.fbab64fa.PNG";